import { createContext } from 'react';

const MobileSidebarContext = createContext({
  selectedMenuItemIndex: -1,
  setSelectedMenuItemIndex: () => {
  }
});

export { MobileSidebarContext };
//# sourceMappingURL=MobileSidebarContext.esm.js.map
